

import BroCodeDisplay from './BroCodeDisplay';

interface ShadowBroContentProps {
  brocode: string;
  pancakeswapUrl: string;
}

const ShadowBroContent = ({ brocode, pancakeswapUrl }: ShadowBroContentProps) => {
  return (
    <div className="space-y-4 mt-16 text-center">
      <div className="mb-6 flex justify-center">
        <div className="inline-block bg-secondary rounded-full p-3 shadow-inner">
          <img 
            src="/lovable-uploads/clr_4.png" 
            alt="Bromentum Logo" 
            className="w-10 h-10 object-contain"
          />
        </div>
      </div>
      <p className="text-lg">Shadow Bros walk the path in silence. But the BroScore remembers everything.</p>
      <p className="text-lg">You've earned +10 BroScore.</p>
      
      <BroCodeDisplay brocode={brocode} />
      
      <p className="text-lg">Upgrade your rank by buying $TOP1 anytime. We'll recheck your wallet later.</p>
      
      <div className="mt-8 flex justify-center">
        <a 
          href={pancakeswapUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-tan text-navy-dark font-bold text-xl px-8 py-3 rounded-lg hover:bg-tan-dark transition-colors shadow-lg"
        >
          Buy $TOP1 Token
        </a>
      </div>
    </div>
  );
};

export default ShadowBroContent;
